<div class="container">
	<img src="assets/img/bg-404.png" alt="" class="img-fluid d-block mx-auto">
	<h1 class="title-404">404</h1>
	<p>Az Ön által keresett aloldal nem található, <span>vagy megváltozott az elérése.</span></p>
</div>
